import { render, staticRenderFns } from "./MemberPOS.vue?vue&type=template&id=37a32132&scoped=true"
import script from "./MemberPOS.vue?vue&type=script&lang=js"
export * from "./MemberPOS.vue?vue&type=script&lang=js"
import style0 from "./MemberPOS.vue?vue&type=style&index=0&id=37a32132&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37a32132",
  null
  
)

export default component.exports